import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export const useOrdersTableHeader = ({
  withDocusign = false,
  isOpenEnded,
  paymentMethodsTypes,
}) => {
  const { t } = useTranslation();

  const [header, setHeader] = useState([]);

  const _header = [
    {
      key: 'viewDetails',
      label: '',
    },
    {
      key: 'actions',
      label: t('shared.actions'),
    },
    {
      key: 'createdAt',
      label: t('shared.creationDate'),
    },
    {
      key: 'status',
      label: t('shared.status'),
    },
    {
      key: 'amountToPay',
      label: t('shared.amountToPay'),
    },
    {
      key: 'tokensOrdered',
      label: t('shared.tokensOrdered'),
    },
    {
      key: 'confirmedPayment',
      label: t('shared.confirmedPayment'),
      info: t('shared.confirmedPaymentInfo'),
    },
    {
      key: 'tokensConfirmed',
      label: t('shared.tokensConfirmed'),
    },
    {
      key: 'tokenPrice',
      label: t('shared.tokenPrice'),
    },
    ...(isOpenEnded
      ? [
          {
            key: 'tokenPriceTime',
            label: t('shared.tokenPriceTime'),
          },
        ]
      : []),
    ...(paymentMethodsTypes.includes('fiat')
      ? [
          {
            key: 'paymentReference',
            label: t('shared.paymentReference'),
          },
        ]
      : []),
    ...(paymentMethodsTypes.includes('crypto')
      ? [
          {
            key: 'txHash',
            label: t('shared.txHash'),
          },
        ]
      : []),
  ];

  useEffect(() => {
    setHeader([..._header]);
  }, [withDocusign, isOpenEnded, paymentMethodsTypes]);

  return header;
};
